import api from './api/axiosConfig';

const eventService = {
  // Get all events with optional filters
  getEvents: async (params = {}) => {
    try {
      const response = await api.get('/events/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching events:', error);
      throw error;
    }
  },

  // Get a single event by ID or slug
  getEvent: async (id) => {
    try {
      const response = await api.get(`/events/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event:', error);
      throw error;
    }
  },

  // Get reviews (comments) for an event
  getEventReviews: async (eventIdentifier) => {
    try {
      const response = await api.get(`/events/${eventIdentifier}/reviews/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event reviews:', error);
      throw error;
    }
  },

  // Create a review/comment for an event. Requires authentication.
  createEventReview: async (eventIdentifier, data) => {
    try {
      const response = await api.post(`/events/${eventIdentifier}/reviews/`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating event review:', error);
      throw error;
    }
  },

  // Create a new event
  createEvent: async (eventData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(eventData).forEach(key => {
        if (key === 'images' && Array.isArray(eventData[key])) {
          // Handle images separately
          eventData[key].forEach((image, index) => {
            formData.append('images', image);
          });
        } else if (
          key !== 'images' &&
          eventData[key] !== undefined &&
          eventData[key] !== null &&
          eventData[key] !== ''
        ) {
          const value =
            typeof eventData[key] === 'boolean' ? String(eventData[key]) : eventData[key];
          formData.append(key, value);
        }
      });

      const response = await api.post('/events/', formData);
      return response.data;
    } catch (error) {
      console.error('Error creating event:', error);
      throw error;
    }
  },

  // Update an event
  updateEvent: async (id, eventData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(eventData).forEach(key => {
        if (key === 'images' && Array.isArray(eventData[key])) {
          // Handle images separately
          eventData[key].forEach((image, index) => {
            formData.append('images', image);
          });
        } else if (
          key !== 'images' &&
          eventData[key] !== undefined &&
          eventData[key] !== null &&
          eventData[key] !== ''
        ) {
          const value =
            typeof eventData[key] === 'boolean' ? String(eventData[key]) : eventData[key];
          formData.append(key, value);
        }
      });

      const response = await api.put(`/events/${id}/`, formData);
      return response.data;
    } catch (error) {
      console.error('Error updating event:', error);
      throw error;
    }
  },

  // Delete an event
  deleteEvent: async (id) => {
    try {
      const response = await api.delete(`/events/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting event:', error);
      throw error;
    }
  },

  // Get events by date range
  getEventsByDateRange: async (startDate, endDate, filters = {}) => {
    try {
      const params = {
        start_date: startDate,
        end_date: endDate,
        ...filters
      };
      const response = await api.get('/events/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching events by date range:', error);
      throw error;
    }
  },

  // Get upcoming events
  getUpcomingEvents: async (filters = {}) => {
    try {
      const today = new Date().toISOString().split('T')[0];
      const params = {
        start_date: today,
        ...filters
      };
      const response = await api.get('/events/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming events:', error);
      throw error;
    }
  },

  // Search events
  searchEvents: async (query, filters = {}) => {
    try {
      const params = {
        search: query,
        ...filters
      };
      const response = await api.get('/events/', { params });
      return response.data;
    } catch (error) {
      console.error('Error searching events:', error);
      throw error;
    }
  },

  // Increment event views
  incrementViews: async (id) => {
    try {
      const response = await api.post(`/events/${id}/increment-views/`);
      return response.data;
    } catch (error) {
      console.error('Error incrementing views:', error);
      throw error;
    }
  },

  // Get event categories from backend
  getCategories: async () => {
    try {
      const response = await api.get('/events/categories/');
      return response.data;
    } catch (error) {
      console.error('Error fetching event categories:', error);
      throw error;
    }
  }
};

export { eventService };
